import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  companies: [],
  sourceJobs: [],
  sourceStages: [],
  destinationJobs: [],
  histories: [],

  isLoadingCompanies: false,
  isLoadingSourceJobs: false,
  isLoadingSourceStages: false,
  isLoadingDestinationJobs: false,

  isTransferring: false,
  isTransferringSuccess: false,
  isLoadingHistories: false,
  isDeletingHistory: false,
};

const candidateTransferSlice = createSlice({
  name: "candidateTransfer",
  initialState: initialState,
  reducers: {
    getActiveCompanies: (state) => {
      state.isLoadingCompanies = true;
    },
    getActiveCompaniesSuccess: (state, action) => {
      state.companies = action.payload;
      state.isLoadingCompanies = false;
    },
    getActiveCompaniesFailed: (state) => {
      state.companies = [];
      state.isLoadingCompanies = false;
    },

    getSourceJobs: (state, action) => {
      state.isLoadingSourceJobs = true;
    },
    getSourceJobsSuccess: (state, action) => {
      state.sourceJobs = action.payload;
      state.isLoadingSourceJobs = false;
    },
    getSourceJobsFailed: (state) => {
      state.sourceJobs = [];
      state.isLoadingSourceJobs = false;
    },

    getSourceStages: (state, action) => {
      state.isLoadingSourceStages = true;
    },
    getSourceStagesSuccess: (state, action) => {
      state.sourceStages = action.payload;
      state.isLoadingSourceStages = false;
    },
    getSourceStagesFailed: (state) => {
      state.sourceStages = [];
      state.isLoadingSourceStages = false;
    },

    getDestinationJobs: (state, action) => {
      state.isLoadingDestinationJobs = true;
    },
    getDestinationJobsSuccess: (state, action) => {
      state.destinationJobs = action.payload;
      state.isLoadingDestinationJobs = false;
    },
    getDestinationJobsFailed: (state) => {
      state.destinationJobs = [];
      state.isLoadingDestinationJobs = false;
    },

    transferCandidate: (state, action) => {
      state.isTransferring = true;
    },
    transferCandidateSuccess: (state) => {
      state.isTransferring = false;
      state.isTransferringSuccess = true;
    },
    transferCandidateFailed: (state) => {
      state.isTransferring = false;
      state.isTransferringSuccess = false;
    },

    getTransferHistories: (state) => {
      state.isLoadingHistories = true;
    },
    getTransferHistoriesSuccess: (state, action) => {
      state.histories = action.payload;
      state.isLoadingHistories = false;
    },
    getTransferHistoriesFailed: (state) => {
      state.histories = [];
      state.isLoadingHistories = false;
    },

    deleteTransferHistories: (state, action) => {
      state.isDeletingHistory = true;
    },
    deleteTransferHistoriesSuccess: (state) => {
      state.isDeletingHistory = false;
    },
    deleteTransferHistoriesFailed: (state) => {
      state.isDeletingHistory = false;
    },
  },
});

export const {
  getActiveCompanies,
  getActiveCompaniesSuccess,
  getActiveCompaniesFailed,
  getSourceJobs,
  getSourceJobsSuccess,
  getSourceJobsFailed,
  getSourceStages,
  getSourceStagesSuccess,
  getSourceStagesFailed,
  getDestinationJobs,
  getDestinationJobsSuccess,
  getDestinationJobsFailed,
  transferCandidate,
  transferCandidateSuccess,
  transferCandidateFailed,
  getTransferHistories,
  getTransferHistoriesSuccess,
  getTransferHistoriesFailed,
  deleteTransferHistories,
  deleteTransferHistoriesSuccess,
  deleteTransferHistoriesFailed,
} = candidateTransferSlice.actions;

export default candidateTransferSlice.reducer;
